import axios from "axios"
import collect from 'collect.js'
import { getCookie, setCookie } from '@/utils/cookies'
import { roomsTitle as flatRoomsTitle, isOneAndHalfRoom as flatIsOneAndHalfRoom } from '@/utils/flats.util'

// Shared "compare flats/units" behaviour used by FlatsTable and RetailTable:
// cookie-persisted selection, the floating compare drawer, the comparison
// modal + PDF export, and the shared table interactions (row click, paging).
export default {
  data() {
    return {
      sortBy: 'flat_status',
      sortDesc: false,
      flatsFilter: {
        stages: this.stages,
        dates: [],
        entrances: [],
        buildings: [],
        rooms: [],
        floors: [],
        availability: 0,
        priceVat: null,
        totalArea: null
      },

      isLoading: false,
      sidebarVisible: '',
      scrollPosition: null,
      selectedItems: [],
      perPage: 10,

      items: [],
      filter: null,
      selectVal: {
        etapa: undefined,
        termin: undefined,
        firstName: undefined,
        lastName: undefined
      },
      compare: [],
      selected: [],
      popupFlats: [],
      images: [],
      comp: [],
      linkComparePdf: `${process.env.VUE_APP_API_URL}/api/v1/apartment-houses/compare?`
    }
  },

  async mounted() {
    this.$root.$on('setFilter', this._onSetFilter)

    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      this._onSetFilter(filter)
    }
    await this.loadFlats()

    if (getCookie('compareFlats')) {
      const selItems = this.selectedItems
      this.comp = JSON.parse(getCookie('compareFlats'))
      this.compare = collect(this.flats).whereIn('flat_penta_internal_id', this.comp).all()
      this.compare.forEach(element => {
        selItems.push(element.flat_penta_internal_id)
      });
    }

    // Docasne, kym sa nepredaju byty v 2 faze, tak ak nie je ziadny volny byt, ale predrezervovane este existuju,
    // tak ako default selectneme predrezervovane, potom toto zmazat, pripadne nechat ak bude treba
    if (this.filteredFlats(this.flatsFilter).length > 0)
      this.flatsFilter.availability = 0
    else
      this.flatsFilter.availability = 1
  },

  beforeDestroy() {
    this.$root.$off('setFilter', this._onSetFilter)
  },

  methods: {
    // Nadpis bytu podľa počtu izieb, null ak sa nedá určiť
    roomsTitle(flat) {
      return flatRoomsTitle(flat)
    },

    isOneAndHalfRoom(flat) {
      return flatIsOneAndHalfRoom(flat)
    },

    scrollToCompareTable(e) {
      if (e.target.classList.contains('delete-item')) {
        return
      }
      document.querySelector('#compare-table').scrollIntoView({behavior: "smooth", block: 'center'})
    },

    isDisabled(item) {
      if (item.flat_status === '2' || item.flat_status === '3' || item.flat_status === '4' || item.flat_status === '5') {
        return 'row-disabled'
      }
    },

    currency: price => {
      let value = parseFloat(price)
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return `${value}`
    },

    showCompareModal() {
      this.isLoading = true
      const requests = [];
      let link = '';
      this.compare.forEach(function(flat){
        link += 'flats[]=' + flat.flat_penta_internal_id + '&'
        requests.push(axios.get(`${process.env.VUE_APP_API_URL}/api/v1/apartment-houses/` + flat.building.building_stage + '/' + flat.flat_penta_internal_id))
      })
      this.linkComparePdf = this.linkComparePdf + link

      axios
          .all(requests)
          .then((response) => {
            this.popupFlats = response
            this.isLoading = false
          }).then(() => {
            this.$bvModal.show('flatsCompareModal')
      })
    },

    addToCompare(isChecked, data) {
      const bbb = this.compare.findIndex(p => p.flat_penta_internal_id == data.item.flat_penta_internal_id);
      if (this.comp.indexOf(data.item.flat_penta_internal_id) == -1) {
        this.compare.push(data.item)
        this.comp.push(data.item.flat_penta_internal_id)
        setCookie('compareFlats', JSON.stringify(this.comp), 1)
        setCookie('selectedFlats', JSON.stringify(this.selectedItems), 1)
      } else {
        this.compare.splice(bbb, 1);
        this.comp.splice(this.comp.indexOf(data.item.flat_penta_internal_id), 1);
        setCookie('compareFlats', JSON.stringify(this.comp), 1)
        setCookie('selectedFlats', JSON.stringify(this.selectedItems), 1)
      }
    },
    deleteFromCompare(data, modal) {
      const aaa = this.compare.findIndex(p => p.flat_penta_internal_id == data.flat_penta_internal_id);
      const bbb = this.comp.findIndex(p => p == data.flat_penta_internal_id);
      this.selectedItems.splice(aaa, 1)
      this.compare.splice(aaa, 1);
      this.comp.splice(bbb, 1);
      setCookie('compareFlats', JSON.stringify(this.comp), 1)
      setCookie('selectedFlats', JSON.stringify(this.selectedItems), 1)

      if (modal) {
        const popupIndex = this.popupFlats.findIndex(p => p.flat_penta_internal_id == data.flat_penta_internal_id)
        this.popupFlats.splice(popupIndex, 1)
      }
    },
    onRowSelected(items, index, event) {
      if(items.flat_status == 4 || items.flat_status == 5) {
        const contactForm = document.getElementById('footer')
        contactForm.scrollIntoView({behavior: "smooth", block: 'center'})
        return
      }
      if (!event.target.classList.contains('custom-control-label')) {
        if (items.flat_status === '0' || items.flat_status === '1') {
          this.$router.push({name:'FlatDetail', params:{id:items.flat_penta_internal_id, stage: items.building.building_stage, filter: this.flatsFilter}});
        }
      } else {
        this.$bvToast.toast(`Do porovnania môžete pridať maximálne 4 byty`, {
          title: `Porovnanie bytov`,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          variant: 'info',
          appendToast: true
        })
      }
    },
    loadMoreFlats() {
      this.perPage += 10;
    },

    _onSetFilter(filter) {
      this.flatsFilter = {
        ...this.flatsFilter,
        ...filter
      }
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.filter) {
        const filter = JSON.parse(this.$route.query.filter)
        this._onSetFilter(filter)

        const currentRoute = this.$router.currentRoute;
        const idToScrollTo = currentRoute.hash;
        this.$nextTick(() => {
          if (idToScrollTo && document.querySelector(idToScrollTo)) {
            document.querySelector(idToScrollTo).scrollIntoView();
          }
        });
      }
    }
  }
}
